import { render, staticRenderFns } from "./StockIndustry.vue?vue&type=template&id=81445868&scoped=true"
import script from "./StockIndustry.vue?vue&type=script&lang=js"
export * from "./StockIndustry.vue?vue&type=script&lang=js"
import style0 from "./StockIndustry.vue?vue&type=style&index=0&id=81445868&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81445868",
  null
  
)

export default component.exports